export const propFirms = [
  {
    id: 'ftmo',
    name: 'FTMO',
    coupon: 'DIARIO10',
    couponDiscount: '10% desconto',
    logo: 'https://public.readdy.ai/ai/img_res/689a94b9208c18e6eb6ff5a771d7c1f4.jpg',
    rating: 4.8,
    badge: 'Mais Popular',
    badgeColor: 'blue',
    profitSplit: '90%',
    maxFunding: '€400.000',
    monthlyFee: '€155',
    drawdown: '10% Max / 5% Diário',
    minDays: '4 dias',
    instruments: 'Forex, Índices, Commodities, Crypto',
    affiliateUrl: '#',
    pros: [
      'Empresa com mais reputação no mercado',
      'Pagamentos consistentes e comprovados',
      'Suporte em múltiplos idiomas',
      'Plataforma MT4/MT5 e cTrader',
      'Programa de escalonamento de contas',
      'Comunidade ativa e recursos educacionais',
    ],
    cons: [
      'Processo de avaliação exigente (2 fases)',
      'Sem trading de criptomoedas nos fins de semana',
      'Taxas mensais relativamente elevadas',
      'Regras de consistency rule',
    ],
    score: 9.4,
  },
  {
    id: 'thinkcapital',
    name: 'ThinkCapital',
    coupon: 'DIARIO1',
    couponDiscount: '10% desconto',
    logo: 'https://readdy.ai/api/search-image?query=ThinkCapital%20prop%20trading%20firm%20logo%20modern%20clean%20minimal%20professional%20dark%20teal%20navy%20badge&width=120&height=60&seq=pf7&orientation=landscape',
    rating: 4.7,
    badge: 'Melhor Forex',
    badgeColor: 'teal',
    profitSplit: '90%',
    maxFunding: '€200.000',
    monthlyFee: '€99',
    drawdown: '10% Max / 5% Diário',
    minDays: '5 dias',
    instruments: 'Forex (70+ pares), Metais, Índices',
    affiliateUrl: 'https://checkout.thinkcapital.com/?refcode=NUNO001',
    pros: [
      'Especialista em Forex — maior diversidade de pares',
      'Alavancagem até 1:100 nos pares principais',
      'Plataforma MT4 e MT5 totalmente integradas',
      'Processo de avaliação 1 fase (mais rápido)',
      'Pagamentos semanais via transferência bancária',
      'Sem restrições de estratégia (scalping, news trading)',
      'Suporte em português disponível',
    ],
    cons: [
      'Sem futuros nem criptomoedas',
      'Capital máximo inferior a algumas concorrentes',
      'Empresa mais recente (menor histórico)',
      'Trailing drawdown nas contas de maior dimensão',
    ],
    score: 9.2,
  },
  {
    id: 'apex',
    name: 'Apex Trader Funding',
    coupon: 'FUTUROS20',
    couponDiscount: '20% desconto',
    logo: 'https://readdy.ai/api/search-image?query=Apex%20Trader%20Funding%20prop%20firm%20logo%20orange%20black%20professional%20bold%20modern%20badge&width=120&height=60&seq=pf3&orientation=landscape',
    rating: 4.5,
    badge: 'Melhor Custo-Benefício',
    badgeColor: 'orange',
    profitSplit: '90%',
    maxFunding: '$300.000',
    monthlyFee: '$137',
    drawdown: '6% Max (sem drawdown diário)',
    minDays: 'Sem mínimo',
    instruments: 'Futuros CME',
    affiliateUrl: '#',
    pros: [
      'Sem drawdown diário (grande vantagem)',
      'Múltiplas contas simultâneas',
      'Promoções frequentes (descontos 80%+)',
      'Processo de avaliação simples (1 fase)',
      'Pagamentos semanais',
      'Regras simples e claras',
    ],
    cons: [
      'Apenas futuros CME',
      'Sem plataforma própria',
      'Suporte ao cliente pode ser lento',
      'Conta de avaliação paga mensalmente',
    ],
    score: 8.8,
  },
  {
    id: 'e8markets',
    name: 'E8 Markets',
    coupon: 'E8TRADER',
    couponDiscount: '10% desconto',
    logo: 'https://readdy.ai/api/search-image?query=E8%20Markets%20prop%20firm%20trading%20logo%20blue%20purple%20modern%20geometric%20minimal%20professional&width=120&height=60&seq=pf5&orientation=landscape',
    rating: 4.4,
    badge: 'Melhor Suporte',
    badgeColor: 'teal',
    profitSplit: '80%',
    maxFunding: '$250.000',
    monthlyFee: '$108',
    drawdown: '8% Max / 4% Diário',
    minDays: 'Sem mínimo',
    instruments: 'Forex, Índices, Metais, Energia',
    affiliateUrl: '#',
    pros: [
      'Excelente suporte ao cliente 24/7',
      'Dashboard intuitivo e moderno',
      'Processo de KYC rápido',
      'Pagamentos rápidos (24-48h)',
      'Withdrawals ilimitados por mês',
    ],
    cons: [
      'Profit split inferior (80%)',
      'Capital máximo limitado',
      'Menos instrumentos disponíveis',
      'Sem criptomoedas',
    ],
    score: 8.5,
  },
  {
    id: 'thefundedtrader',
    name: 'The Funded Trader',
    coupon: 'DIARIO12',
    couponDiscount: '12% desconto',
    logo: 'https://readdy.ai/api/search-image?query=The%20Funded%20Trader%20prop%20firm%20logo%20red%20black%20bold%20modern%20professional%20badge%20text&width=120&height=60&seq=pf4&orientation=landscape',
    rating: 4.3,
    badge: 'Alta Alavancagem',
    badgeColor: 'red',
    profitSplit: '90%',
    maxFunding: '$600.000',
    monthlyFee: '$130',
    drawdown: '12% Max / 5% Diário',
    minDays: '5 dias',
    instruments: 'Forex, Índices, Commodities, Crypto',
    affiliateUrl: '#',
    pros: [
      'Capital máximo mais elevado do mercado',
      'Drawdown máximo generoso (12%)',
      'Múltiplos planos de avaliação',
      'Suporte em português disponível',
      'Programa de afiliados competitivo',
    ],
    cons: [
      'Empresa mais recente (menor histórico)',
      'Alguns relatos de atrasos em pagamentos',
      'Regras de trading complexas',
      'Custos de avaliação elevados para contas grandes',
    ],
    score: 8.3,
  },
  {
    id: 'mff',
    name: 'My Forex Funds',
    coupon: 'MFF5OFF',
    couponDiscount: '5% desconto',
    logo: 'https://readdy.ai/api/search-image?query=My%20Forex%20Funds%20prop%20firm%20logo%20teal%20green%20white%20modern%20professional%20minimal%20text%20badge&width=120&height=60&seq=pf6&orientation=landscape',
    rating: 3.8,
    badge: 'Em Recuperação',
    badgeColor: 'gray',
    profitSplit: '75-85%',
    maxFunding: '$300.000',
    monthlyFee: '$84',
    drawdown: '12% Max / 5% Diário',
    minDays: 'Sem mínimo (Rapid)',
    instruments: 'Forex, Commodities, Índices',
    affiliateUrl: '#',
    pros: [
      'Plano Rapid sem fase de avaliação',
      'Taxa de entrada baixa',
      'Sem restrições de estratégia',
      'Conta demo gratuita disponível',
    ],
    cons: [
      'Histórico regulatório complicado (ação CFTC)',
      'Operações temporariamente suspensas em alguns países',
      'Confiança do mercado afetada',
      'Profit split abaixo da concorrência',
    ],
    score: 6.9,
  },
  {
    id: 'fim',
    name: 'Topstep',
    coupon: 'TRADER15',
    couponDiscount: '15% desconto',
    logo: 'https://readdy.ai/api/search-image?query=Topstep%20futures%20trading%20prop%20firm%20logo%20green%20white%20professional%20minimal%20badge&width=120&height=60&seq=pf2&orientation=landscape',
    rating: 4.6,
    badge: 'Melhor para Futuros',
    badgeColor: 'green',
    profitSplit: '100% (1ª retirada) / 90%',
    maxFunding: '$300.000',
    monthlyFee: '$49',
    drawdown: '6% Max / 2% Diário',
    minDays: 'Sem mínimo',
    instruments: 'Futuros CME (ES, NQ, CL, GC)',
    affiliateUrl: '#',
    pros: [
      'Especialista em futuros (melhor da categoria)',
      '100% do lucro na 1ª retirada',
      'Taxa mensal muito acessível',
      'Sem fase de avaliação dupla',
      'Plataforma NinjaTrader e Tradovate',
      'Coaching de trading incluído',
    ],
    cons: [
      'Apenas futuros (sem forex ou ações)',
      'Drawdown diário restrito',
      'Horários de trading limitados',
      'Sem operações durante comunicados económicos',
    ],
    score: 6.5,
  },
];
